import React from 'react';
import { FaCheck } from 'react-icons/fa';
import  Chatbot  from '../../components/ui/chatbot';
const ServicePage = () => {
  const services = [
    {
      id: 1,
      name: "Wedding Photography",
      description: "Capture your special day with comprehensive wedding coverage including ceremony, reception, and couple portraits.",
      price: 2500,
      duration: "8-10 hours",
      popular: true,
      image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&h=600&fit=crop",
      features: [
        "Full day coverage",
        "2 photographers",
        "500+ edited photos",
        "Online gallery",
        "Print release included"
      ]
    },
    {
      id: 2,
      name: "Portrait Session",
      description: "Professional portrait photography for individuals, families, or couples in studio or outdoor locations.",
      price: 350,
      duration: "1-2 hours",
      popular: false,
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop",
      features: [
        "1-2 hour session",
        "Multiple outfit changes",
        "50+ edited photos",
        "Online gallery"
      ]
    },
    {
      id: 3,
      name: "Event Photography",
      description: "Professional coverage for corporate events, parties, and special occasions with candid and posed shots.",
      price: 800,
      duration: "4-6 hours",
      popular: false,
      image: "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=800&h=600&fit=crop",
      features: [
        "Event coverage",
        "Candid photography",
        "Group photos",
        "200+ edited photos"
      ]
    },
    {
      id: 4,
      name: "Commercial Photography",
      description: "Professional product, headshot, and business photography for marketing and promotional materials.",
      price: 1200,
      duration: "3-4 hours",
      popular: false,
      image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=600&fit=crop",
      features: [
        "Product photography",
        "Professional headshots",
        "Commercial license",
        "High-res files"
      ]
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12 mt-20 mb-20">
      <h1 className="text-3xl font-bold text-center mb-4">Our Photography Services</h1>
      <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">
        Explore our professional photography services tailored to capture your special moments
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map(service => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </div>
  );
};

const ServiceCard = ({ service }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
      {/* Service Image */}
<div className="h-48 overflow-hidden group">
  <img 
    src={service.image} 
    alt={service.name}
    className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105 group-hover:brightness-110"
  />
</div>

      {/* Service Info */}
      <div className="p-6">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-xl font-bold">{service.name}</h3>
          {service.popular && (
            <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full">
              Popular
            </span>
          )}
        </div>

        <div className="flex justify-between items-center mb-4">
          <span className="text-gray-600">{service.duration}</span>
          <span className="text-xl font-bold">${service.price}</span>
        </div>

        <p className="text-gray-700 mb-4">{service.description}</p>

        <ul className="space-y-2 mb-4">
          {service.features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <FaCheck className="text-green-500 mt-1 mr-2 flex-shrink-0" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>


      </div>
      <Chatbot />
    </div>
  );
};

export default ServicePage;